import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  style: {"display":"inline-block"}
}
const _hoisted_3 = {
  key: 0,
  style: {"color":"#ccc"}
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 3,
  style: {"margin":"4px"}
}
const _hoisted_7 = {
  key: 4,
  class: "mr-4"
}
const _hoisted_8 = {
  key: 1,
  style: {"color":"#ccc","font-weight":"bold"}
}

import { ref } from 'vue';
  import { isEmptyData } from '@/utils/common';

  interface Props {
    dataList: Recordable[];
    spanClickTemplate?: string;
    otherSpanTemplate?: string;
    tip?: string;
    canEdit?: boolean;
    canDelete?: boolean;
    spanTemplateFunc?: any;
    spanClick?: any;
    addFunc?: any;
    addButtonSpan?: string;
    deleteFunc?: any;
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    dataList: { default: () => {
      let obj: Recordable[] = [];
      return obj;
    } },
    spanClickTemplate: { default: '' },
    otherSpanTemplate: { default: '' },
    tip: { default: '—' },
    canEdit: { default: false },
    canDelete: { default: false },
    spanTemplateFunc: { default: null },
    spanClick: { default: null },
    addFunc: { default: null },
    addButtonSpan: { default: '' },
    deleteFunc: { default: null }
  },
  setup(__props: any) {

const props = __props as { dataList: Recordable[], spanClickTemplate: string, otherSpanTemplate: string, tip: string, canEdit: boolean, canDelete: boolean, spanTemplateFunc: any, spanClick: any, addFunc: any, addButtonSpan: string, deleteFunc: any }

  

  const showIcon = ref<boolean>(false);
  const mouseMove = () => {
    showIcon.value = !showIcon.value;
  };

  const getSpan = (data: Recordable, spanTemplate = props.spanClickTemplate) => {
    let res: any = null;
    if (props.spanTemplateFunc) {
      res = props.spanTemplateFunc(data);
    } else if (spanTemplate) {
      const allFields = Object.keys(data);
      let span = spanTemplate;
      allFields.forEach((field) => {
        span = span.replaceAll(`{${field}}`, data[field]);
      });
      res = span;
    } else {
      res = data;
    }
    return res;
  };

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", {
    onMouseover: mouseMove,
    onMouseout: mouseMove
  }, [
    (!_unref(isEmptyData)(__props.dataList))
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dataList, (data, index) => {
            return (_openBlock(), _createElementBlock("span", { key: index }, [
              (!_unref(isEmptyData)(getSpan(data)))
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (_unref(isEmptyData)(getSpan(data)))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "—"))
                      : (__props.spanClick)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            onClick: ($event: any) => (__props.spanClick(data))
                          }, _toDisplayString(getSpan(data)), 9, _hoisted_4))
                        : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(getSpan(data)), 1)),
                    (!_unref(isEmptyData)(__props.otherSpanTemplate))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(getSpan(data, __props.otherSpanTemplate)), 1))
                      : _createCommentVNode("", true),
                    _withDirectives(_createVNode(_component_svg_icon, {
                      iconName: "CloseOutlined",
                      style: {"font-size":"16px"},
                      onClick: ($event: any) => (__props.deleteFunc(data))
                    }, null, 8, ["onClick"]), [
                      [_vShow, __props.canDelete && showIcon.value && __props.deleteFunc]
                    ]),
                    (__props.dataList.indexOf(data) < __props.dataList.length - 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, "，"))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(__props.tip), 1)),
    (!_unref(isEmptyData)(__props.addButtonSpan))
      ? _withDirectives((_openBlock(), _createElementBlock("a", {
          key: 2,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.addFunc())),
          style: {"margin-left":"12px"}
        }, _toDisplayString(__props.addButtonSpan), 513)), [
          [_vShow, __props.addFunc && __props.canEdit]
        ])
      : _withDirectives((_openBlock(), _createBlock(_component_svg_icon, {
          key: 3,
          iconName: "PlusOutlined",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.addFunc())),
          style: {"color":"#4885ed","margin-left":"12px"}
        }, null, 512)), [
          [_vShow, __props.addFunc && __props.canEdit]
        ])
  ], 32))
}
}

})